export interface VideoEntry {
  id: string;
  youtubeVideoId: string;
  organizationId?: string;
  url: string;
  createdAt: number;
}

// En producción, nginx hace proxy de /api al backend, así que la base URL es relativa.
// En desarrollo, se puede apuntar a localhost:8080 con la variable de entorno.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

/**
 * Obtiene los datos de un video por su UUID desde el endpoint público.
 * Corresponde al endpoint GET /api/public/videos/:uuid del backend (sin auth).
 */
export async function fetchVideoByUUID(uuid: string): Promise<VideoEntry> {
  const response = await fetch(`${API_BASE_URL}/api/public/videos/${uuid}`);

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Video no encontrado');
    }
    throw new Error(`Error del servidor: ${response.status}`);
  }

  return response.json();
}
